import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import {sectors} from "../../../constants/jsonConstant";
import Navbar from "../../../components/Landing_page_Navbar/index";
import {Link} from "react-router-dom";
import "./style.css";
/* ---------------------------------------------------------------------
   2) ICONS — minimal inline SVGs (no external icon library needed)
   --------------------------------------------------------------------- */
const iconBase = {
  width: 22,
  height: 22,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const icons = {
  telecom: (p) => (<svg {...iconBase} {...p}><path d="M4 20h.01M9 20v-4M14 20v-8M19 20V6" /></svg>),
  internet: (p) => (<svg {...iconBase} {...p}><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c2.5 2.7 3.8 6 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-6-3.8-9s1.3-6.3 3.8-9Z" /></svg>),
  cloud: (p) => (<svg {...iconBase} {...p}><path d="M7 18a4.5 4.5 0 0 1-.5-8.97A5.5 5.5 0 0 1 17 8.5a4 4 0 0 1-.5 7.98H7Z" /></svg>),
  it: (p) => (<svg {...iconBase} {...p}><rect x="4" y="4" width="16" height="16" rx="2" /><path d="M9 9h6v6H9zM2 9h2M2 15h2M20 9h2M20 15h2M9 2v2M15 2v2M9 20v2M15 20v2" /></svg>),
  ai: (p) => (<svg {...iconBase} {...p}><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1" /><circle cx="12" cy="12" r="3" /></svg>),
  mobile: (p) => (<svg {...iconBase} {...p}><rect x="7" y="2" width="10" height="20" rx="2" /><path d="M11 18h2" /></svg>),
  software: (p) => (<svg {...iconBase} {...p}><path d="m8 9-4 3 4 3M16 9l4 3-4 3M13 5l-2 14" /></svg>),
  hardware: (p) => (<svg {...iconBase} {...p}><rect x="6" y="6" width="12" height="12" rx="1.5" /><path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3" /></svg>),
  electronics: (p) => (<svg {...iconBase} {...p}><path d="M13 2 4 14h6l-1 8 9-12h-6z" /></svg>),
  manufacturers: (p) => (<svg {...iconBase} {...p}><path d="M3 20V10l6 4v-4l6 4V8l6 4v8H3Z" /></svg>),
  packaging: (p) => (<svg {...iconBase} {...p}><path d="M21 8 12 3 3 8l9 5 9-5Z" /><path d="M3 8v9l9 5 9-5V8M12 13v9" /></svg>),
  advertising: (p) => (<svg {...iconBase} {...p}><path d="M3 11v2a2 2 0 0 0 2 2h1l3 5V4L6 9H5a2 2 0 0 0-2 2Z" /><path d="M15 8a4 4 0 0 1 0 8M18 5a8 8 0 0 1 0 14" /></svg>),
  marketing: (p) => (<svg {...iconBase} {...p}><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1" /></svg>),
  logistics: (p) => (<svg {...iconBase} {...p}><path d="M2 8h11v9H2zM13 11h4l4 3v3h-8z" /><circle cx="6" cy="19" r="1.6" /><circle cx="17" cy="19" r="1.6" /></svg>),
  property: (p) => (<svg {...iconBase} {...p}><path d="M3 11 12 3l9 8" /><path d="M5 10v10h14V10" /></svg>),
  recruitment: (p) => (<svg {...iconBase} {...p}><circle cx="9" cy="8" r="3" /><path d="M2 20c0-3.3 3.1-6 7-6s7 2.7 7 6M17 8a3 3 0 1 1 3.4 3M15 14c2.7.3 5 2.1 5 5" /></svg>),
  cybersecurity: (p) => (<svg {...iconBase} {...p}><path d="M12 3l8 3v6c0 4.5-3.2 7.7-8 9-4.8-1.3-8-4.5-8-9V6l8-3Z" /><path d="m9.5 12 1.8 1.8L15 10" /></svg>),
  datacenter: (p) => (<svg {...iconBase} {...p}><rect x="4" y="3" width="16" height="7" rx="1.2" /><rect x="4" y="14" width="16" height="7" rx="1.2" /><path d="M8 6.5h.01M8 17.5h.01" /></svg>),
  api: (p) => (<svg {...iconBase} {...p}><path d="M9 3v4M15 3v4M9 17v4M15 17v4M3 9h4M3 15h4M17 9h4M17 15h4" /><rect x="7" y="7" width="10" height="10" rx="1.5" /></svg>),
  emerging: (p) => (<svg {...iconBase} {...p}><path d="M12 2c3 2 5 5.5 5 9a5 5 0 0 1-10 0c0-3.5 2-7 5-9Z" /><path d="M9 18c0 2 1.3 3 3 3s3-1 3-3" /></svg>),
  banking: (p) => (<svg {...iconBase} {...p}><path d="M3 10 12 4l9 6" /><path d="M4 10h16v2H4zM6 12v7M10 12v7M14 12v7M18 12v7M3 21h18" /></svg>),
  check: (p) => (<svg {...iconBase} {...p} strokeWidth={2.4}><path d="M5 13l4 4L19 7" /></svg>),
  arrowDown: (p) => (<svg {...iconBase} {...p}><path d="M12 4v16M6 14l6 6 6-6" /></svg>),
  arrowRight: (p) => (<svg {...iconBase} {...p}><path d="M4 12h16M14 6l6 6-6 6" /></svg>),
};

/* ---------------------------------------------------------------------
   3) SECTOR DATA — content for the ~20 repeating "industry" blocks
   --------------------------------------------------------------------- */




/* ---------------------------------------------------------------------
   5) SMALL REUSABLE PRESENTATIONAL HELPERS
   --------------------------------------------------------------------- */
const Eyebrow = ({ icon: Icon, children }) => (
  <div className="sz-eyebrow">{Icon && <Icon width={14} height={14} />}{children}</div>
);

const HeadingBlock = ({ eyebrow, eyebrowIcon, title, children, left }) => (
  <div className={`sz-heading-block ${left ? "sz-left" : ""}`}>
    {eyebrow && <Eyebrow icon={eyebrowIcon}>{eyebrow}</Eyebrow>}
    <h2>{title}</h2>
    {children && <p>{children}</p>}
  </div>
);

const TagRow = ({ tags, left }) => (
  <div className={`sz-tag-grid ${left ? "sz-left" : ""}`}>
    {tags.map((t) => (<span className="sz-chip" key={t}>{t}</span>))}
  </div>
);

const FlowChain = ({ steps, finalIndex }) => (
  <div className="sz-flow-chain">
    {steps.map((s, i) => (
      <React.Fragment key={s}>
        <span className={`sz-chip ${finalIndex === i ? "sz-chip--primary" : "sz-chip-outline"}`}>{s}</span>
        {i < steps.length - 1 && <icons.arrowRight className="sz-flow-arrow" />}
      </React.Fragment>
    ))}
  </div>
);

const FlowVertical = ({ steps }) => (
  <div className="sz-flow-vertical">
    {steps.map((s, i) => (
      <React.Fragment key={s}>
        <div className={`sz-flow-step ${i === steps.length - 1 ? "sz-flow-final" : ""}`}>{s}</div>
        {i < steps.length - 1 && (
          <div className="sz-flow-arrow-wrap"><icons.arrowDown width={18} height={18} /></div>
        )}
      </React.Fragment>
    ))}
  </div>
);

const CtaBar = ({ children }) => <div className="sz-cta-bar">{children}</div>;
const QuoteBox = ({ children }) => <div className="sz-quote-box">{children}</div>;

const InfoCardGrid = ({ items }) => (
  <div className="sz-card-grid">
    {items.map((item) => {
      const Icon = icons[item.icon] || icons.it;
      return (
        <div className="sz-info-card " key={item.title}>
          <div className="sz-icon-wrap m-auto mb-4"><Icon /></div>
          <h4 className="m-auto text-center">{item.title}</h4>
          {item.desc && <p className="m-auto text-center mt-2">{item.desc}</p>}
        </div>
      );
    })}
  </div>
);

/* ---------------------------------------------------------------------
   6) SECTOR SECTION — one reusable template for all ~20 industry blocks
   --------------------------------------------------------------------- */
function SectorSection({ data, alt }) {
  const Icon = icons[data.icon] || icons.it;
  return (
    <section className={`sz-sector ${alt ? "sz-section-alt" : ""}`}>
      <div className="container">
        <div className="sz-sector-head">
          <span className="sz-sector-icon"><Icon /></span>
          <h3 className="sz-sector-title">{data.title}</h3>
        </div>
        <p className="sz-sector-blurb">{data.blurb}</p>

        {data.tags && (
          <div className="sz-sector-tags">
            {data.tags.map((tag) => (<span className="sz-chip" key={tag}>{tag}</span>))}
          </div>
        )}

        {data.benefits && (
          <>
            <p className="sz-sector-benefits-label">Potential Benefits</p>
            <div className="row g-3">
              {data.benefits.map((b) => (
                <div className="col-12 col-md-6 col-lg-4" key={b}>
                  <div className="sz-benefit-item">
                    <icons.check className="sz-benefit-check" />
                    <span>{b}</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {data.note && <p className="sz-sector-note">{data.note}</p>}

        {data.flow && (
          <div className="sz-sector-flow">
            {data.flow.map((step, i) => (
              <React.Fragment key={step}>
                <span className="sz-chip sz-chip-outline">{step}</span>
                {i < data.flow.length - 1 && <icons.arrowRight className="sz-flow-arrow" />}
              </React.Fragment>
            ))}
          </div>
        )}

        {data.cta && <div className="sz-sector-cta">{data.cta}</div>}
      </div>
    </section>
  );
}

/* ---------------------------------------------------------------------
   7) PAGE — everything assembled
   --------------------------------------------------------------------- */
export default function Investment() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const updateBackToTopVisibility = () => {
      setShowBackToTop(window.scrollY > 320);
    };

    updateBackToTopVisibility();
    window.addEventListener("scroll", updateBackToTopVisibility, {
      passive: true,
    });
    return () =>
      window.removeEventListener("scroll", updateBackToTopVisibility);
  }, []);

  return (
    <div className="sz-page">
   
<Navbar />
      {/* HERO */}
      <section className="sz-hero">
        <div className="container">
          <h2 className="sz-hero-headline">The Global Business Resource System For Investment Opportunities, Business Connections, And Growth</h2>
          <div className="sz-hero-divider" />
          <p className="sz-hero-sub">
            One Ecosystem. Multiple Business Sectors. Multiple Revenue Streams. Unlimited Possibilities.
          </p>
          <p className="sz-hero-paragraph">
            From Consumer to Opportunity. From Opportunity to Business. From Business to Growth.
          </p>
          <div className="sz-hero-actions mt-3">
            <a href="#investment-thesis" className="sz-btn sz-btn-primary">Review Investment Thesis</a>
            <a href="#revenue-streams" className="sz-btn sz-btn-outline">Revenue Streams</a>
          </div>
        </div>
      </section>

      {/* CORE PROPOSITION */}
      <section className="sz-section" id="investment-thesis">
        <div className="container">
          <HeadingBlock eyebrow="Core Proposition" title="Invest in SELECTEZI">
            Invest in the Future of Connected Business.
          </HeadingBlock>
          <div className="row justify-content-center">
            <div className="col-lg-9 text-center">
              <p>SELECTEZI is building a new kind of digital business ecosystem designed to connect people, businesses, products, services, resources and opportunities through one connected platform.</p>
              <p>SELECTEZI is not simply a place to buy or sell. It is where people can discover what they need, show what they have, connect with businesses, discover opportunities, promote their capabilities and grow.</p>
            </div>
          </div>
          <QuoteBox>SELECTEZI connects people with possibilities</QuoteBox>
        </div>
      </section>

      {/* BUSINESS ECOSYSTEM BUILT FOR EVERYONE */}
      <section className="sz-section sz-section-alt">
        <div className="container">
          <HeadingBlock title="A Business Ecosystem Built for Everyone">
            Every business depends on other businesses. A retailer needs wholesalers. A wholesaler needs manufacturers. A manufacturer needs raw materials. Businesses need transportation, property, services and employees. Consumers need products and services. Service providers need customers. Businesses need visibility and promotion. People need opportunities. SELECTEZI brings these connections together.
          </HeadingBlock>
          <TagRow tags={["Retailers", "Wholesalers", "Manufacturers", "Raw Material Providers", "Gems & Jewelry", "Second-Hand & Used Items", "Homemade Businesses", "Farming", "Recycling", "Used Vehicles", "Service Providers", "Transportation", "Property", "Food", "Job & Recruitment Companies"]} />
          <p className="text-center mt-4 mb-0 fw-semibold" style={{ color: "var(--sz-primary-dark)" }}>
            And many more opportunities can be developed as the ecosystem grows.
          </p>
        </div>
      </section>

      {/* EVERY BUSINESS CAN BE A RESOURCE */}
      <section className="sz-section">
        <div className="container">
          <HeadingBlock title="Every Business Can Be a Resource">
            SELECTEZI is designed around a simple principle: every business can be a resource to another business.
          </HeadingBlock>
          <div className="row g-3 justify-content-center">
            {[
              "A manufacturer can be a resource for a wholesaler",
              "A wholesaler can be a resource for a retailer",
              "A retailer can be a resource for a consumer",
              "A transportation company can be a resource for a manufacturer",
              "A service provider can be a resource for a restaurant",
              "A property provider can be a resource for a business",
            ].map((t) => (
              <div className="col-md-6 col-lg-4" key={t}>
                <div className="sz-benefit-item"><icons.arrowRight className="sz-benefit-check" /><span>{t}</span></div>
              </div>
            ))}
            <div className="col-lg-8">
              <div className="sz-benefit-item justify-content-center">
                <icons.arrowRight className="sz-benefit-check" />
                <span>A recruitment company can be a resource for every growing organization</span>
              </div>
            </div>
          </div>
          <CtaBar>When businesses connect, opportunities are created</CtaBar>
        </div>
      </section>

      {/* THE SELECTEZI BUSINESS CONNECTION */}
      <section className="sz-section sz-section-alt">
        <div className="container text-center">
          <h2 className="mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>The SELECTEZI Business Connection</h2>
          <FlowChain steps={["Raw Material", "Manufacturer", "Wholesaler", "Retailer", "Consumer"]} finalIndex={4} />
          <p className="text-uppercase small fw-bold text-muted mt-4 mb-2">Before the business reaches the consumer</p>
          <TagRow tags={["Transportation", "Property", "Services", "Jobs", "Funding", "Marketing", "Technology"]} />
          <p className="mt-4 fw-semibold" style={{ color: "var(--sz-primary-dark)" }}>
            One connected ecosystem. Multiple business relationships. Countless opportunities.
          </p>
        </div>
      </section>

      {/* WHY SELECTEZI */}
      <section className="sz-section">
        <div className="container text-center">
          <h2 className="mb-2" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Why SELECTEZI?</h2>
          <p className="mb-4">Businesses do not need only customers. They need:</p>
          <TagRow tags={["Visibility", "Suppliers", "Customers", "Resources", "Employees", "Transportation", "Property", "Services", "Marketing", "Technology", "New Assets", "New Opportunities"]} />
          <p className="mt-4 mb-4">SELECTEZI is designed to bring these resources closer together.</p>
          <CtaBar>Find what you need Show what you have Discover what you can become</CtaBar>
        </div>
      </section>

      {/* REVENUE ECOSYSTEM */}
      <section className="sz-section sz-section-alt" id="revenue-streams">
        <div className="container">
          <HeadingBlock eyebrow="Business Model" title="Our Revenue Ecosystem">
            SELECTEZI is designed with multiple revenue streams, enabling more than one path for sustainable business growth.
          </HeadingBlock>
          <div className="row g-4">
            {[
              { n: "01", t: "Premium Business Subscriptions", d: "Businesses across SELECTEZI's different sectors can join premium packages designed to provide enhanced business capabilities, visibility, promotional tools and platform benefits.", cta: "Recurring subscription revenue" },
              { n: "02", t: "Advertising", d: "SELECTEZI provides businesses with opportunities to promote products, services, showcases and more. Businesses can use SELECTEZI's tools to boost visibility across their target audience.", cta: "Business visibility creates advertising opportunity" },
              { n: "03", t: "SELECTEZI Marketing Agent", d: "A dedicated marketing agent for eligible premium businesses. The marketing agent helps businesses promote products and services, discover opportunities and maintain their business presence within SELECTEZI.", cta: "Dedicated premium package fee" },
              { n: "04", t: "SELECTEZI AI", d: "SELECTEZI AI helps businesses discover opportunities, including automated search, connect intelligently, promote content, and discover partnership opportunities across the ecosystem.", cta: "AI-powered services fee" },
            ].map((c) => (
              <div className="col-md-6" key={c.n}>
                <div className="sz-info-card h-100">
                  <span className="sz-eyebrow">{c.n}</span>
                  <h4>{c.t}</h4>
                  <p>{c.d}</p>
                  <p className="fw-bold small mt-2" style={{ color: "var(--sz-primary)" }}>{c.cta}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HUMAN MARKETING + AI + BUSINESS ECOSYSTEM */}
      <section className="sz-section">
        <div className="container text-center">
          <h2 className="mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Human Marketing + AI + Business Ecosystem</h2>
          <p className="mb-4">SELECTEZI brings three powerful elements together:</p>
          <InfoCardGrid items={[
            { icon: "manufacturers", title: "The Business", desc: "What the business offers." },
            { icon: "marketing", title: "The Marketing Agent", desc: "How the business is promoted." },
            { icon: "ai", title: "SELECTEZI AI", desc: "How information, discovery and opportunity are surfaced." },
          ]} />
          <div className="mt-4">
            <FlowVertical steps={["Business + Marketing + AI", "Discovery + Connection + Opportunity", "Growth"]} />
          </div>
        </div>
      </section>

      {/* REVENUE ENGINE */}
      <section className="sz-section sz-section-alt">
        <div className="container text-center">
          <h2 className="mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>The SELECTEZI Revenue Engine</h2>
          <FlowVertical steps={[
            "Businesses Join", "Businesses Reach Customers", "Users Discover Products, Services & Resources",
            "Businesses Gain Growth Visibility", "Premium Subscriptions", "Marketing Services", "Advertising",
            "AI-Powered Services", "More Business Activity", "More Users & Businesses", "A Stronger Ecosystem",
          ]} />
        </div>
      </section>

      {/* GROWTH FLYWHEEL */}
      <section className="sz-section">
        <div className="container text-center">
          <h2 className="mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>The SELECTEZI Growth Flywheel</h2>
          <FlowVertical steps={[
            "More Businesses", "More Products & Services", "More Resources", "More Discovery", "More Promotion",
            "More Opportunities", "More Business Value", "More Premium Services", "More Advertising & Marketing",
            "More Revenue", "Higher Ecosystem Growth",
          ]} />
          <p className="fw-semibold mt-3" style={{ color: "var(--sz-primary-dark)" }}>And the cycle continues.</p>
        </div>
      </section>

      {/* ONE BUSINESS MANY CONNECTIONS */}
      <section className="sz-section sz-section-alt">
        <div className="container">
          <HeadingBlock title="One Business Can Create Many Connections" />
          <div className="row g-3">
            {[
              { title: "A Manufacturer May Need:", tags: ["Raw Materials", "Transportation", "Property", "Employees", "Services", "Wholesalers", "Retailers"] },
              { title: "A Retailer May Need:", tags: ["Customers", "Wholesalers", "Manufacturers", "Transportation", "Employees", "Property", "Services"] },
              { title: "A Restaurant May Need:", tags: ["Food Suppliers", "Transportation", "Property", "Employees", "Services", "Equipment"] },
              { title: "A Service Provider May Need:", tags: ["Customers", "Businesses", "Transportation", "Employees", "Other Services"] },
            ].map((b) => (
              <div className="col-md-6" key={b.title}>
                <div className="sz-info-card h-100">
                  <h4>{b.title}</h4>
                  <TagRow left tags={b.tags} />
                </div>
              </div>
            ))}
          </div>
          <CtaBar>SELECTEZI connects the needs behind the business</CtaBar>
        </div>
      </section>

      {/* FROM ONE BUSINESS TO A COMPLETE ECOSYSTEM */}
      <section className="sz-section">
        <div className="container text-center">
          <HeadingBlock title="From One Business to a Complete Ecosystem" />
          <div className="row justify-content-center g-2">
            {[
              "A single business can create connections with multiple sectors",
              "A single sector can create opportunities for multiple businesses",
              "Multiple businesses create a stronger network",
              "A stronger network creates greater discovery",
              "Greater discovery creates more opportunities",
            ].map((t) => (
              <div className="col-lg-8" key={t}>
                <div className="sz-benefit-item"><icons.check className="sz-benefit-check" /><span>{t}</span></div>
              </div>
            ))}
          </div>
          <p className="fw-bold mt-4" style={{ color: "var(--sz-primary)" }}>That is the SELECTEZI ecosystem.</p>
        </div>
      </section>

      {/* BUILT FOR LOCAL, DESIGNED FOR GLOBAL */}
      <section className="sz-section sz-section-alt text-center">
        <div className="container">
          <h2 className="mb-2" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Built for Local Markets Designed for Global Expansion</h2>
          <p className="mb-4">SELECTEZI is designed to expand from:</p>
          <FlowChain steps={["Business", "City", "Region", "Country", "Global Market"]} finalIndex={4} />
          <p className="fw-bold mt-3" style={{ color: "var(--sz-primary-dark)" }}>Local Connections. Regional Opportunities. Global Vision.</p>
        </div>
      </section>

      {/* INVESTMENT OPPORTUNITY */}
      <section className="sz-section">
        <div className="container">
          <HeadingBlock eyebrow="Strategic Capital Allocation" title="Investment Opportunity">
            SELECTEZI is building infrastructure for a world where businesses are increasingly connected through digital technology. Investment in SELECTEZI supports the development and expansion of:
          </HeadingBlock>
          <InfoCardGrid items={[
            { icon: "it", title: "Platform Technology" },
            { icon: "ai", title: "Artificial Intelligence" },
            { icon: "manufacturers", title: "Business Acquisition" },
            { icon: "advertising", title: "Marketing Infrastructure" },
            { icon: "internet", title: "Regional Expansion" },
            { icon: "emerging", title: "International Expansion" },
            { icon: "recruitment", title: "Strategic Partnerships" },
            { icon: "it", title: "Business Operations" },
            { icon: "api", title: "Technology & Integrations" },
          ]} />
        </div>
      </section>

      {/* INVEST IN THE ECOSYSTEM */}
      <section className="sz-section sz-section-alt text-center">
        <div className="container">
          <h2 className="mb-2" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Invest in the Ecosystem</h2>
          <p className="mb-4">SELECTEZI provides an opportunity to participate in the development of a platform designed around multiple sectors and multiple revenue streams.</p>
          <p className="fw-bold text-uppercase small mb-3">Investment can support the growth of:</p>
          <TagRow tags={["Technology Platform", "Workforce & Business Verticals", "SELECTEZI AI", "Marketing Infrastructure", "Regional Expansion", "Technology", "Strategic Business Development"]} />
        </div>
      </section>

      {/* WHAT SELECTEZI SEEKS FROM INVESTORS */}
      <section className="sz-section">
        <div className="container">
          <HeadingBlock title="What SELECTEZI Seeks From Investors">
            SELECTEZI welcomes investors who can contribute more than capital and value.
          </HeadingBlock>
          <div className="row g-3">
            {[
              { t: "Capital", d: "To accelerate development and expansion." },
              { t: "Experience", d: "Industry knowledge that can strengthen our business." },
              { t: "Network", d: "Access to businesses, organizations and strategic relationships." },
              { t: "Market Access", d: "Opportunities to enter new regions and markets." },
              { t: "Technology", d: "AI, software, infrastructure, cybersecurity and digital capabilities." },
              { t: "Marketing", d: "Experience in building brands, market presence and business awareness." },
            ].map((c) => (
              <div className="col-md-6 col-lg-4" key={c.t}>
                <div className="sz-info-card h-100"><h4>{c.t}</h4><p>{c.d}</p></div>
              </div>
            ))}
          </div>
          <QuoteBox>Strategic value: Relationships that add to the long-term SELECTEZI vision</QuoteBox>
          <CtaBar>Capital + Experience + Network + Market Access + Strategic Value</CtaBar>
        </div>
      </section>

      {/* THE INVESTOR'S OPPORTUNITY */}
      <section className="sz-section sz-section-alt">
        <div className="container text-center">
          <HeadingBlock title="The Investor's Opportunity">SELECTEZI is designed to create value through:</HeadingBlock>
          <div className="row justify-content-center g-2">
            {[
              { t: "Becoming Premium Revenue:", d: "Business subscriptions across multiple sectors" },
              { t: "Advertising Revenue:", d: "Business and product visibility" },
              { t: "Marketing Revenue:", d: "Professional promotional capabilities within Premium services and future offerings" },
              { t: "AI Revenue:", d: "AI-powered services and capabilities" },
              { t: "Future Technology Revenue:", d: "Additional integrations, tools and digital business services on the platform over time" },
            ].map((row) => (
              <div className="col-lg-9" key={row.t}>
                <div className="sz-benefit-item text-start">
                  <icons.check className="sz-benefit-check" />
                  <span><strong>{row.t}</strong> {row.d}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MORE THAN A MARKETPLACE */}
      <section className="sz-section text-center">
        <div className="container">
          <Eyebrow>Market Opportunity &amp; Strategic Infrastructure</Eyebrow>
          <h2 className="mb-3" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>More Than a Marketplace</h2>
          <p className="mb-3">SELECTEZI is not simply:</p>
          <TagRow tags={["A Retail Platform", "A Wholesale Platform", "A Job Platform", "A Property Platform", "A Food Platform", "A Service Directory", "An Advertising Website", "A Traditional E-commerce Marketplace", "A Social Media Platform"]} />
          <div className="sz-quote-box mt-4">
            <p className="sz-eyebrow justify-content-center mb-2">SELECTEZI is designed to be:</p>
            <h3 className="mb-0" style={{ fontSize: "1.5rem" }}>A Business Resource &amp; Opportunity Ecosystem</h3>
          </div>
        </div>
      </section>

      {/* THE SELECTEZI DIFFERENCE */}
      <section className="sz-section sz-section-alt">
        <div className="container text-center">
          <HeadingBlock title="The SELECTEZI Difference" />
          <div className="row g-4 mb-3">
            <div className="col-md-6">
              <div className="sz-info-card h-100">
                <p className="sz-eyebrow">Legacy Thinking</p>
                <p>Traditional platforms often focus on a single relationship.</p>
                <p className="fw-bold">Buyer ⇄ Seller</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="sz-info-card h-100">
                <p className="sz-eyebrow">SELECTEZI's Approach</p>
                <p>SELECTEZI expands the relationship.</p>
                <p className="fw-bold">Person ⇄ Business ⇄ Resource ⇄ Service ⇄ Opportunity</p>
              </div>
            </div>
          </div>
          <div className="row g-2 justify-content-center">
            {[
              "A person can become a customer",
              "A business can become a supplier",
              "A supplier can become a partner",
              "A wholesaler can become a manufacturer",
            ].map((t) => (
              <div className="col-md-6 col-lg-3" key={t}>
                <div className="sz-benefit-item"><icons.arrowRight className="sz-benefit-check" /><span>{t}</span></div>
              </div>
            ))}
          </div>
          <CtaBar>SELECTEZI is where people discover what they can become</CtaBar>
        </div>
      </section>

      {/* OUR VISION */}
      <section className="sz-section">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-7">
              <Eyebrow>Our Vision</Eyebrow>
              <h2 className="mb-3" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Our Vision</h2>
              <p>We envision a world where finding a business opportunity is as natural as finding a product. Where a business can discover not only customers, but the resources it needs to grow. Where a consumer can discover not only what to buy, but what they may become. Where businesses can promote themselves continuously. Where AI can help people navigate opportunities intelligently. Where businesses from different sectors can discover one another. Where local businesses can become visible beyond their immediate region.</p>
            </div>
            <div className="col-lg-5">
              <div className="sz-info-card text-center h-100 d-flex flex-column justify-content-center">
                <div className="sz-icon-wrap mx-auto"><icons.emerging /></div>
                <h4>Where Connection Creates Opportunity</h4>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* THE SELECTEZI PROMISE */}
      <section className="sz-section sz-section-alt">
        <div className="container text-center">
          <Eyebrow>Our Promise</Eyebrow>
          <h2 className="mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>The SELECTEZI Promise</h2>
          <InfoCardGrid items={[
            { icon: "internet", title: "Find What You Need" },
            { icon: "packaging", title: "Show What You Have" },
            { icon: "emerging", title: "Discover What You Can Become" },
            { icon: "telecom", title: "Connect With Possibilities" },
            { icon: "manufacturers", title: "Create Opportunities" },
            { icon: "advertising", title: "Grow Your Business" },
          ]} />
        </div>
      </section>

      {/* INVEST IN THE FUTURE — DARK BAND */}
      <section className="sz-dark-band">
        <div className="container">
          <Eyebrow icon={null}>Invest in the Future of Connected Business</Eyebrow>
          <h2>SELECTEZI</h2>
          <p>From Consumer to Opportunity. From Business to Growth. From Opportunity to Business.</p>
          <div className="sz-divider-light" />
          <p className="fw-bold text-white">Invest in SELECTEZI. Invest in Connected Business. Invest in Opportunity.</p>
        </div>
      </section>

      {/* STRATEGIC TECHNOLOGY & INFRASTRUCTURE PARTNERS */}
      <section className="sz-section">
        <div className="container">
          <Eyebrow>Global Network / Infrastructure Opportunity</Eyebrow>
          <h2 className="mb-3" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Strategic Technology &amp; Infrastructure Partners</h2>
          <p className="mb-4">SELECTEZI is designed to operate as a global digital business ecosystem, creating opportunities for organizations that provide the technology infrastructure that businesses and users depend on every day: Cloud Service Providers, Internet Service Providers, Data Centers, Hosting Companies, Connectivity Providers, Technology Infrastructure Companies and Digital Service Providers can become potential strategic partners of SELECTEZI.</p>
          <div className="sz-info-card">
            <p className="sz-eyebrow">A New Partnership Opportunity</p>
            <div className="row g-2">
              {[
                "Provide SELECTEZI its main business infrastructure",
                "Provide cloud infrastructure and technology services",
                "Develop joint business acquisition opportunities",
                "Explore co marketing opportunities",
                "Introduce SELECTEZI as a business resource and opportunity operator",
                "Support hosting, connectivity, security and scalability",
                "Support enterprise customer acquisition",
                "Explore regional expansion partnerships",
                "Support SELECTEZI's expansion and international operator relationships",
                "Create technology integration partnerships",
                "Participate in strategic business development",
                "Explore strategic investment opportunities",
              ].map((t) => (
                <div className="col-md-6" key={t}>
                  <div className="d-flex gap-2 align-items-start py-1">
                    <icons.check className="sz-benefit-check" /><span className="small">{t}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FROM SERVICE PROVIDER TO STRATEGIC PARTNER */}
      <section className="sz-section sz-section-alt text-center">
        <div className="container">
          <Eyebrow>Growing Strategic Relationship</Eyebrow>
          <h2 className="mb-2" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>From Service Provider to Strategic Partner</h2>
          <p className="mb-4">SELECTEZI does not view cloud and internet companies only as technology suppliers. A major infrastructure organization can become:</p>
          <FlowChain steps={["Service Provider", "Technology Partner", "Strategic Partner", "Marketing Partner", "Potential Investor"]} finalIndex={4} />
        </div>
      </section>

      {/* POTENTIAL PARTNER CATEGORIES */}
      <section className="sz-section">
        <div className="container"> 
          <Eyebrow>Diverse Partner Network</Eyebrow>
          <h2 className="mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Potential Partner Categories</h2>
          <p className="mb-4">SELECTEZI can explore partnerships with organizations providing:</p>
          <InfoCardGrid items={[
            { icon: "cloud", title: "Cloud Computing", desc: "Infrastructure, storage, database, computing and hosting solutions." },
            { icon: "internet", title: "Internet Services", desc: "Internet connectivity, broadband and business internet services." },
            { icon: "datacenter", title: "Data Centers", desc: "Physical infrastructure, colocation and regional data storage." },
            { icon: "api", title: "Hosting & Infrastructure", desc: "Web hosting, application hosting and managed infrastructure." },
            { icon: "telecom", title: "Connectivity Networks", desc: "Fiber, network, telecom and connectivity infrastructure." },
            { icon: "cybersecurity", title: "Cybersecurity", desc: "Cloud security, network security, identity and monitoring." },
            { icon: "ai", title: "AI & Technology Infrastructure", desc: "AI platforms, APIs, computing and technology infrastructure." },
            { icon: "software", title: "Digital Business Services", desc: "Software, digital tools and business-enablement services." },
          ]} />
        </div>
      </section>

      {/* STRATEGIC INVESTMENT OPPORTUNITY */}
      <section className="sz-section sz-section-alt">
        <div className="container text-center">
          <Eyebrow>Investment Pathway for Strategic Partners</Eyebrow>
          <h2 className="mb-3" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Strategic Investment Opportunity</h2>
          <p className="mb-4">Organizations participating in the SELECTEZI ecosystem may also explore opportunities to become strategic investors, where appropriate. A strategic investor could contribute more than capital.</p>
          <CtaBar>Capital + Technology + Infrastructure + Customers + Network + Market Access + Experience</CtaBar>
          <p className="mt-4">This can create a two way strategic relationship between SELECTEZI and major technology organizations.</p>
        </div>
      </section>

      {/* THE SELECTEZI VISION */}
      <section className="sz-section text-center">
        <div className="container">
          <Eyebrow>A Broad Network</Eyebrow>
          <h2 className="mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>The SELECTEZI Vision</h2>
          <p className="mb-4">SELECTEZI is building relationships across the entire business ecosystem.</p>
          <FlowVertical steps={["People", "Businesses", "Products & Services", "Resources", "Technology", "Cloud & Internet Infrastructure", "Global Business Opportunities"]} />
          <p className="fw-semibold mt-4" style={{ color: "var(--sz-primary-dark)" }}>Every organization that connects the digital world can potentially help connect the SELECTEZI ecosystem.</p>
        </div>
      </section>

      {/* PARTNERSHIP MESSAGE */}
      <section className="sz-section sz-section-alt">
        <div className="container text-center">
          <Eyebrow>Our Partnership Message</Eyebrow>
          <h2 className="mb-3" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Partnership Message</h2>
          <p className="mb-4">SELECTEZI welcomes strategic discussions with organizations providing cloud services, internet services, hosting, data centers, connectivity, AI, infrastructure and other digital infrastructure services. Organizations that can help SELECTEZI reach businesses and markets can potentially become more than service providers — they can become ecosystem partners, distribution partners, strategic partners and, where mutually appropriate, investors.</p>
          <div className="sz-info-card d-inline-block px-5 py-3 mb-4">
            <p className="sz-eyebrow justify-content-center mb-1">Building Together</p>
            <h3 className="mb-0" style={{ color: "var(--sz-primary)" }}>SELECTEZI</h3>
          </div>
          <div className="row g-2 justify-content-center">
            {["From Infrastructure to Business", "From Connectivity to Opportunity", "From Technology to Growth"].map((t) => (
              <div className="col-md-4" key={t}><span className="sz-chip d-block">{t}</span></div>
            ))}
          </div>
        </div>
      </section>

      {/* PARTNERSHIP & INVESTMENT MODELS */}
      <section className="sz-section">
        <div className="container">
          <Eyebrow>Investment Model Types</Eyebrow>
          <h2 className="mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Partnership &amp; Investment Models (03 – 10)</h2>
          <div className="row g-3">
            {[
              { n: "03", t: "Technology Investment", d: "Technology companies can participate through technology development, software, AI, cloud, infrastructure, cybersecurity or other technology capabilities with the parties.", tags: ["Technology", "SELECTEZI", "AI"] },
              { n: "04", t: "Cloud & Infrastructure Partnership", d: "Cloud providers, data centers, hosting companies, internet service and connectivity providers can become one of SELECTEZI's important infrastructure and strategic partners.", tags: ["Infrastructure", "Hosting", "Strategic Partner"] },
              { n: "05", t: "General Investment", d: "Investors or organizations can explore participation in SELECTEZI's expansion into the market, regional partners and involved investments in the market landscape.", tags: ["City", "Region", "International Market"] },
              { n: "06", t: "Business Development Partnership", d: "Organizations can contribute business development, business acquisition, market intelligence, enterprise relationships, Distribution, Marketing capabilities and Leadership involved.", tags: [] },
              { n: "07", t: "Marketing & Promotion Partnership", d: "Marketing companies, media organizations, technology platforms and business networks can help introduce SELECTEZI to businesses, consumers and potentially markets through promotion.", tags: ["Promotion", "Customer Access", "Business Development"] },
              { n: "08", t: "Corporate / Institutional Investment", d: "Companies, investment groups, family offices, institutions and other qualified organizations can contact SELECTEZI to discuss potential investment or strategic participation.", tags: [] },
              { n: "09", t: "Joint Venture / Special Partnership", d: "Where commercially and mutually appropriate, SELECTEZI may explore joint ventures or special partnerships for particular strategic opportunities across regions, industries or business types.", tags: [] },
              { n: "10", t: "Future Investment Opportunities", d: "As SELECTEZI expands, additional investment and participation structures may become available over time. Business growth, new markets, AI development, Strategic partnerships, Infrastructure requirements, International expansion.", tags: [] },
            ].map((c) => (
              <div className="col-md-6" key={c.n}>
                <div className="sz-info-card h-100">
                  <span className="sz-eyebrow">{c.n}</span>
                  <h4>{c.t}</h4>
                  <p>{c.d}</p>
                  {c.tags.length > 0 && <TagRow left tags={c.tags} />}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHO CAN INVEST WITH SELECTEZI */}
      <section className="sz-section sz-section-alt">
        <div className="container">
          <Eyebrow>Capital &amp; Strategic Backing</Eyebrow>
          <h2 className="mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Who Can Invest With SELECTEZI?</h2>
          <InfoCardGrid items={[
            { icon: "recruitment", title: "Individual Investors", desc: "People who believe in the SELECTEZI vision and want to explore meaningful opportunities." },
            { icon: "manufacturers", title: "Entrepreneurs & Business Owners", desc: "Business leaders who can provide capital, experience, network or market access." },
            { icon: "it", title: "Technology Companies", desc: "Organizations that can contribute technology, software or AI infrastructure." },
            { icon: "cloud", title: "Cloud Service Providers", desc: "Cloud organizations that can explore technology partnerships, market investment." },
            { icon: "telecom", title: "Internet & Telecommunication Companies", desc: "Connectivity organizations that can become potential premium and market partners." },
            { icon: "datacenter", title: "Data Centers & Hosting Companies", desc: "Infrastructure providers that can participate through technology, hosting or strategic investment." },
            { icon: "banking", title: "Investment Companies & Family Offices", desc: "Professional investors can explore single or multiple appropriate investment structures." },
            { icon: "property", title: "Corporations & Institutions", desc: "Large organizations can explore strategic capital, strategic partnerships, infrastructure or market access." },
            { icon: "emerging", title: "Regional Partners", desc: "Organizations can explore participation in specific regions and geographic expansion." },
          ]} />
        </div>
      </section>

      {/* INVESTMENT IS MORE THAN MONEY */}
      <section className="sz-section text-center">
        <div className="container">
          <Eyebrow>Multi-Dimensional Value Base</Eyebrow>
          <h2 className="mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Investment Is More Than Money</h2>
          <p className="mb-4">SELECTEZI believes that the strongest partnerships can combine multiple forms of value:</p>
          <div className="row g-3">
            {[
              { icon: "banking", t: "Capital", d: "Funding for technology, expansion and acquisition." },
              { icon: "it", t: "Technology", d: "AI, cloud, software, infrastructure and integrations." },
              { icon: "internet", t: "Market Access", d: "Customers, businesses and international markets." },
              { icon: "recruitment", t: "Network", d: "Business relationships, strategic introductions and partnerships." },
              { icon: "ai", t: "Experience", d: "Industry knowledge, management and business development expertise." },
              { icon: "datacenter", t: "Infrastructure", d: "Cloud, hosting, servers, connectivity and data security." },
              { icon: "advertising", t: "Brand & Promotion", d: "Marketing, media, distribution and business visibility." },
            ].map((c) => (
              <div className="col-md-6 col-lg-3" key={c.t}>
                <div className="sz-info-card h-100">
                  <div className="sz-icon-wrap mx-auto">{React.createElement(icons[c.icon])}</div>
                  <h4>{c.t}</h4>
                  <p>{c.d}</p>
                </div>
              </div>
            ))}
          </div>
          <CtaBar>Capital + Technology + Network + Market Access + Experience together these can help build a global business ecosystem</CtaBar>
        </div>
      </section>

      {/* INTERESTED IN INVESTING */}
      <section className="sz-section sz-section-alt">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-6">
              <h2 className="mb-3" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Interested in Investing or Partnering With SELECTEZI?</h2>
              <p>Whether you are an individual investor, entrepreneur, technology company, cloud provider, internet service company, investment group, institution or regional partner, we welcome you to explore appropriate opportunities to join us.</p>
              <p className="fw-semibold" style={{ color: "var(--sz-primary)" }}>Tell us what you can offer. Tell us what you'd like to build. Let's explore what we can create together.</p>
            </div>
            <div className="col-lg-6">
              <div className="sz-form-card">
                <h4>Investment &amp; Strategic Partnership</h4>
                <p className="small mb-1">Send us an email at:</p>
                <p className="fw-bold mb-3" style={{ color: "var(--sz-primary)" }}>investment@selectezi.com</p>
                <p className="small text-uppercase fw-bold text-muted mb-2">Please Include</p>
                <div className="sz-form-field-list">
                  <span>Your name / organization</span>
                  <span>Industry / region</span>
                  <span>Type of organization</span>
                  <span>Proposed involvement or partnership</span>
                  <span>Partnership or investment interest</span>
                  <span>Contact information</span>
                </div>
                <p className="small text-muted mb-0">All investment opportunities are subject to due diligence, applicable laws, regulatory requirements, commercial terms and definitive agreements. No investment or return is guaranteed.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WELCOME THE WORLD'S LEADERS */}
      <section className="sz-section text-center">
        <div className="container">
          <Eyebrow>Global Alliance Network</Eyebrow>
          <h2 style={{ fontWeight: 800, fontSize: "var(--sz-fs-h1)" }}>Every Industry Every Technology Every Connection Every Opportunity</h2>
          <p className="mt-2 mb-0" style={{ fontWeight: 800, color: "var(--sz-heading)", fontSize: "1.4rem" }}>SELECTEZI Welcomes the World's Business &amp; Technology Leaders</p>
          <p className="mt-3">SELECTEZI is building a global Business Resource &amp; Opportunity Ecosystem designed to connect people, businesses, products, services, resources, technology and opportunities. We welcome organizations from every major sector and technology sector to explore opportunities to join SELECTEZI as Service Partners, Technology Partners, Strategic Partners, Business Partners or Investors.</p>
        </div>
      </section>

      {/* SECTOR PARTNERSHIP BREAKDOWN */}
      <section className="sz-section sz-section-alt">
        <div className="container">
          <Eyebrow>Cross Industry Sector Alignment</Eyebrow>
          <h2 style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Sector Partnership Breakdown</h2>
          <p>High performance partnerships tailored for specific global industries that increasingly interlink with SELECTEZI.</p>
        </div>
      </section>

      {sectors.map((s, i) => (<SectorSection key={s.title} data={s} alt={i % 2 === 1} />))}

      {/* ONE COMPANY, MANY OPPORTUNITIES */}
      <section className="sz-section text-center">
        <div className="container">
          <h2 className="mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>One Company Can Create Many Opportunities</h2>
          <p className="mb-3">A single manufacturer may need:</p>
          <TagRow tags={["Banking", "Internet", "Cloud", "IT", "Software", "Hardware", "Raw Materials", "Transportation", "Advertising & Marketing", "Employees", "Property", "Recruitment"]} />
          <CtaBar>Businesses do not operate alone They operate through connections</CtaBar>
        </div>
      </section>

      {/* HOW ORGANIZATIONS CAN JOIN */}
      <section className="sz-section sz-section-alt">
        <div className="container">
          <h2 className="text-center mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>How Organizations Can Join SELECTEZI</h2>
          <p className="text-center mb-4">Organizations can explore participation as:</p>
          <div className="row g-3">
            {[
              { n: "1", t: "Service Partner", d: "Provide services required by the ecosystem.", icon: "software" },
              { n: "2", t: "Technology Partner", d: "Provide software, hardware, AI or infrastructure.", icon: "it" },
              { n: "3", t: "Marketing Partner", d: "Help promote SELECTEZI.", icon: "marketing" },
              { n: "4", t: "Distributor Partner", d: "Introduce SELECTEZI to businesses and markets.", icon: "logistics" },
              { n: "5", t: "Strategic Partner", d: "Combine resources, expertise and relationships.", icon: "recruitment" },
              { n: "6", t: "Regional Partner", d: "Help expand SELECTEZI into a specific market.", icon: "internet" },
              { n: "7", t: "Investor", d: "Provide capital or other agreed investment support, and evaluate legal requirements.", icon: "banking" },
              { n: "8", t: "Ecosystem Partner", d: "Build a long-term relationship connecting technology, business and investment.", icon: "emerging" },
            ].map((c) => (
              <div className="col-md-6 col-lg-3" key={c.n}>
                <div className="sz-info-card h-100">
                  <span className="sz-eyebrow">{c.n}</span>
                  <div className="sz-icon-wrap">{React.createElement(icons[c.icon])}</div>
                  <h4>{c.t}</h4>
                  <p>{c.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BIGGER NETWORK, BIGGER OPPORTUNITY */}
      <section className="sz-section text-center">
        <div className="container">
          <h2 className="mb-3" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>The Bigger the Partnership Network, the Bigger the Opportunity Network</h2>
          <TagRow tags={["Banking", "Telecom", "Internet", "Cloud", "IT", "AI", "Software", "Hardware", "Manufacturers", "Packaging", "Transportation", "Marketing & Advertising", "Real Estate", "Retail", "Consumers"]} />
          <p className="fw-bold mt-3" style={{ color: "var(--sz-primary)" }}>SELECTEZI connects the ecosystem.</p>
        </div>
      </section>

      {/* JOIN SELECTEZI - BUILD TOGETHER checklist */}
      <section className="sz-section sz-section-alt">
        <div className="container">
          <h2 className="text-center mb-4" style={{ fontWeight: 700, fontSize: "var(--sz-fs-h2)" }}>Join SELECTEZI Build the Future Together</h2>
          <p className="text-center mb-4">We welcome:</p>
          <div className="row g-2">
            {[
              "Banks", "Telecom Companies", "Internet Service Providers", "Cloud Providers",
              "IT Companies", "AI Companies", "Manufacturers", "Packaging Companies",
              "Electronics Companies", "Hardware Companies", "Advertising Companies", "Marketing Companies",
              "Mobile & Android App Companies", "Digital Platforms", "Telecommunication Companies", "Software Companies",
              "Recruitment / HR Companies", "Property Companies", "Data Centers", "Logistics Companies",
            ].map((t) => (
              <div className="col-md-6 col-lg-3" key={t}>
                <div className="d-flex align-items-center gap-2 py-1">
                  <icons.check className="sz-benefit-check" /><span className="small">{t}</span>
                </div>
              </div>
            ))}
          </div>
          <CtaBar>Any company in any technology, business or service category can explore how it fits</CtaBar>
        </div>
      </section>

      {/* BECOME A PARTNER OR INVESTOR — contact form */}
      <section className="sz-section">
        <div className="container">
          <Eyebrow>Partnership &amp; Investment Inquiries</Eyebrow>
          <h2 style={{ fontWeight: 800, fontSize: "var(--sz-fs-h2)" }}>Become a SELECTEZI Partner or Investor</h2>
          <p className="mb-4">If your organization can provide technology, infrastructure, products, services, customers, market access, marketing, investment or strategic value, SELECTEZI welcomes you to start a conversation.</p>
          <div className="sz-form-card">
            <div className="row">
              <div className="col-md-7">
                <p className="small text-uppercase fw-bold text-muted mb-1">Send Us an Email</p>
                <p className="fw-bold mb-3" style={{ color: "var(--sz-primary)" }}>partnership@selectezi.com</p>
                <p className="small text-uppercase fw-bold text-muted mb-2">Fill Us In</p>
                <div className="sz-form-field-list">
                  <span>Who you are</span>
                  <span>What you provide</span>
                  <span>Regions you operate in</span>
                  <span>What you can contribute</span>
                  <span>Which opportunities you see</span>
                  <span>How you would like to work with SELECTEZI</span>
                </div>
                <a href="mailto:partnership@selectezi.com" className="sz-btn sz-btn-primary mt-2">Submit Partner / Strategic Inquiry</a>
              </div>
              <div className="col-md-5 d-flex align-items-center justify-content-center">
                <div className="sz-info-card text-center">
                  <p className="small text-uppercase fw-bold text-muted mb-1">Direct Partnership Inquiry Line</p>
                  <p className="fw-bold mb-0" style={{ color: "var(--sz-primary)" }}>partnership@selectezi.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA — DARK BAND */}
      <section className="sz-dark-band">
        <div className="container">
                <p className="text-uppercase fw-bold small mb-3" style={{ color: "var(--sz-primary-100)" }}>Your Business. Your Technology. Your Network. Your Opportunity.</p>
          <h2 style={{ fontSize: "clamp(1.75rem, 4vw, 2.75rem)" }}>SELECTEZI Ecosystem</h2>
          <p className="fw-semibold text-white">Connect. Discover. Create Opportunities. Grow Together.</p>
          <div className="sz-divider-light" />
          <p>From Consumer to Opportunity.</p>
          <p>From Opportunity to Business.</p>
          <p>From Business to Growth.</p>
          <h3 className="text-white mt-3" style={{ fontWeight: 700 }}>SELECTEZI Welcomes the World to Build With Us</h3>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="selectezi-footer p-3">
  <div className=" d-flex align-items-center justify-content-between flex-wrap gap-2">
    <span>
      &copy; 2025 SELECTEZI Inc. All rights reserved.
    </span>

    <div className="d-flex align-items-center gap-3">
      <Link to="/general-terms">General Terms</Link>
      <Link to="/privacy-policy">Privacy Policy</Link>
    </div>
  </div>
</footer>
      <button
        type="button"
        className={`sz-investment-back-to-top${showBackToTop ? " sz-investment-back-to-top--visible" : ""}`}
        aria-label="Back to top"
        title="Back to top"
        tabIndex={showBackToTop ? 0 : -1}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <ArrowUp size={21} strokeWidth={2.2} aria-hidden="true" />
      </button>
    </div>
  );
}
